interface LockStateCellProps {
  lockState: boolean
}

export const LockStateCell: React.FC<LockStateCellProps> = ({ lockState }) => {
  return <div>{lockState ? <i className="fa fa-lock fa-solid" aria-hidden="true" /> : '-'}</div>
}
